import { createContext } from "react";


const LastBlocksContext = createContext({});
LastBlocksContext.displayName = "LastBlocks";

export default LastBlocksContext;
